import { render, staticRenderFns } from "./BookingDefault.vue?vue&type=template&id=e196b3f2&"
import script from "./BookingDefault.vue?vue&type=script&lang=js&"
export * from "./BookingDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports